<template>
  <router-link
    :to="{
      name: route,
      params: {}
    }"
    aria-label="Expoleap Home Page"
    class="d-flex"
    style="justify-content: center; position: relative"
    title="Expoleap Home Page"
    @click.native="$vuetify.goTo(0)"
  >
    <div class="app-logo">
      <!-- <v-img
        alt="Expoleap Logo"
        class="mx-9"
        :class="{
          shrink: useMini,
          grow: !useMini
        }"
        :style="{
          'max-height': useMini ? '40px' : '60px'
        }"
        aspect-ratio="1.9"
        :src="
          src
            ? src
            : useMini
            ? miniCompanyImage
            : useDark
            ? darkCompanyImage
            : lightCompanyImage
        "
        v-on="$attrs"
        transition="scroll-y-transition"
        :min-width="useMini ? 40 : 100"
        :min-height="useMini ? 40 : 20"
        :height="useMini ? null : 45"
      /> -->
      <!-- <v-scroll-y-transition group mode="in-out" leave-absolute> -->
      <img
        v-if="useMini"
        :src="miniCompanyImage"
        alt=""
        srcset=""
        role="presentation"
        class="spotlight"
        style="height: 28px;"
      />
      <img
        v-else
        :src="useDark ? darkCompanyImage : lightCompanyImage"
        alt=""
        srcset=""
        role="presentation"
        class="logo-text"
        style="height: 28px;"
      />
      <!-- </v-scroll-y-transition> -->
    </div>
  </router-link>
</template>

<script>
import { get } from 'vuex-pathify';
export default {
  name: 'BaseVuetifyLogo',
  computed: {
    miniCompanyImage: get('app/miniCompanyImage'),
    darkCompanyImage: get('app/darkCompanyImage'),
    lightCompanyImage: get('app/lightCompanyImage')
  },
  props: {
    route: {
      type: String,
      default: 'select'
    },
    src: {
      type: String,
      required: false
    },
    size: {
      type: [String, Number],
      default: null
    },
    useDark: {
      type: Boolean,
      default: false
    },
    useMini: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="sass" scoped>
.app-logo
  align-items: center
  display: flex
  height: 48px
  padding: 0 20px
  cursor: pointer

.spotlight
  position: relative
  top: -1px

.logo-text
  min-height: 42px
  // margin-left: 12px
  transition: opacity .3s cubic-bzier(0.4, 0, 0.2, 1)

// vuetify styling
.v-navigation-drawer__content
  box-shadow: 0 -1px 0 #2a4865 inset
  flex-grow: 1
</style>
